/**
 * Obsługuje sticky menu na karcie produktu (menu produktu)
 */
app.service('productMenu',function(html, broker, cookie, sticky, console) {
	var isEnabled=cookie.isEmpty('sticky-off');
	var $self, $window, $links;
	var isSticky=false, isClicked=true, breakpointHeight=0, breakpointMax=0, timeout, activeTab=false;
	var section = {};
	var stickyHeight = 0;

	function setElements() {
		$self = $('#menu-product');
		$window=$(window);
		$links=$self.find('a');
		$links.each(function() {
			var tab=$(this).data('tab');
			section[tab]={
				menu:$(this),
				name:tab,
				viewed:false,
				offset:0,
				tab:$('.product-tab-'+tab)
			};
		});
	}
	function generateHeight(){
		if(isClicked){
			$links.each(function(index) {
				var tab=$(this).data('tab');
				if ($(this).parent().hasClass('is-hidden') || $(this).parent().is(':hidden')) {
					const nextTab = $links.eq(index + 1).data('tab');
					section[tab].offset = $('.product-tab-'+nextTab).offset().top;
				} else {
					section[tab].offset= $('.product-tab-'+tab).offset().top;
				}
			});
			var $lastTab=$('.product-tab:visible:last');
			breakpointMax=$lastTab.offset().top + $lastTab.height();
			isClicked=false;
		}
	}
	function scroll(force) {
		generateHeight();
		if(stickyHeight != sticky.height()){
			stickyHeight = sticky.height();
			$self.css('top',stickyHeight);
		}
		var currentScrollPosition = $window.scrollTop();
		if(currentScrollPosition>breakpointMax){
			//włączamy sticky
			html.remove('product-menu-fixed');
			isSticky=false;
		}else if(currentScrollPosition>breakpointHeight && (!isSticky || force)){
			//włączamy sticky
			html.add('product-menu-fixed');
			isSticky=true;
		}else if(currentScrollPosition<breakpointHeight && (isSticky  || force)){
			//wyłączamy sticky
			html.remove('product-menu-fixed');
			isSticky=false;
		}
		var $newTab=false;

		Object.keys(section).forEach(tab => {
			if(section[tab].offset - sticky.topPadding < currentScrollPosition + 170) {
				$newTab = section[tab];
			}
		});

		if($newTab.name!=activeTab){
			$self.attr('data-tab', $newTab.name)
			$self.find('li').removeClass('active-nav');
			clearTimeout(timeout);
			activeTab=$newTab.name;
			if(typeof $newTab != "boolean"){
				$newTab.menu.closest('li').addClass('active-nav');
				broker.trigger('PRODUCT_MENU_TAB_CHANGE', {activeTab, nextTab: $newTab.name});
				timeout=setTimeout(function(){
					if(!$newTab.viewed){
						//console.log(activeTab);
						$newTab.viewed=true;
					}
				},3000);
			}else{
				broker.trigger('PRODUCT_MENU_TAB_CHANGE', false);
				$self.removeAttr('data-tab');
			}
		}
	}
	function brakepoint(){
		breakpointHeight=$self.offset().top-67;
	}
	function setEvents() {
		if(isEnabled){
			broker.on('PAGE_SCROLL', function(){
				scroll();
			});
			$('#product-tabs').click(function(){
				isClicked=true;
			});
			$(window).on('promotion-bar-close, product-menu-scroll', function(){
				brakepoint();
				scroll(true);
			});
			$(window).on('resize', function(){
				isClicked=true;
			});
		}
		$links.on('click', function(event) {
			event.preventDefault();
			clickTab($(this).data('tab'));
		});
		$('#header').on('transitionend webkitTransitionEnd oTransitionEnd', () => scroll(true));
	}
	function scrollToTab(target, speed = 500) {
		UA.pageInteraction('Sticky', target);
		var $tab;
		if(section[target]) {
			$tab = section[target].tab;
		} else {
			$tab = $('.product-tab-' + target);
		}
		if($tab.length && $tab.is(':visible')){
			$.scrollTo($tab, speed);
		}
	}

	function clickTab(tab){
		section[tab].viewed=true;
		scrollToTab(tab);
	}

	function init() {
		setElements();
		if($self.length){
			setEvents();
			brakepoint();
			scroll();
		}
	}

	function outletMode(outletMode){
		if(outletMode){
			$self.addClass('outlet-tabs');
		}else{
			$self.removeClass('outlet-tabs');
		}
		refresh();
	}

	function refresh() {
		isClicked = true;
		scroll(true);
	}

	return {
		init,
		outletMode,
		scroll:scrollToTab
	};
});
